import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledMessageBubble,
  StyledMessageRow,
  StyledTypingDot,
  StyledTypingDots,
  StyledTypingLabel,
} from '../Assistant.styles';

const AssistantTypingIndicator = () => {
  const { t } = useTranslation();

  return (
    <StyledMessageRow>
      <StyledMessageBubble>
        <StyledTypingDots aria-hidden>
          <StyledTypingDot $delay={0} />
          <StyledTypingDot $delay={0.15} />
          <StyledTypingDot $delay={0.3} />
        </StyledTypingDots>
        <StyledTypingLabel>{t('assistant.thinking')}</StyledTypingLabel>
      </StyledMessageBubble>
    </StyledMessageRow>
  );
};

export default AssistantTypingIndicator;
